import * as tslib_1 from "tslib";
import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../_models/user-name-display-result-dto';
const ɵ0 = () => Date, ɵ1 = () => UserNameDisplayResultDto, ɵ2 = () => UserNameDisplayResultDto, ɵ3 = () => Date, ɵ4 = () => UserNameDisplayResultDto, ɵ5 = () => UserNameDisplayResultDto, ɵ6 = () => UserNameDisplayResultDto, ɵ7 = () => Date, ɵ8 = () => UserNameDisplayResultDto;
export class WorkFlowWorkOrderResultDto {
    get responsibleUserDisplayText() {
        return Utils.notNullAndDefined(this.responsible) ? this.responsible.displayName : '';
    }
    get createdByUserDisplayText() {
        return Utils.notNullAndDefined(this.createdBy) ? this.createdBy.displayName : '';
    }
    get dashboardResponsibleUserDisplayText() {
        return Utils.notNullOrEmpty(this.dashboardResponsible)
            ? this.dashboardResponsible.map((r) => r.displayName).join(', ')
            : '';
    }
    get primaryAcamDisplayText() {
        return Utils.notNullOrEmpty(this.primaryAcam) ? this.primaryAcam.map((r) => r.displayName).join(', ') : '';
    }
    get primaryCamDisplayText() {
        return Utils.notNullOrEmpty(this.primaryCam) ? this.primaryCam.map((r) => r.displayName).join(', ') : '';
    }
    get statusChangedByDisplayText() {
        return Utils.notNullAndDefined(this.statusChangedBy) ? this.statusChangedBy.displayName : '';
    }
    get invoiceIdText() {
        return Utils.notNullOrEmpty(this.invoiceIds) ? this.invoiceIds.join(', ') : '';
    }
    get taskIdText() {
        return Utils.notNullOrEmpty(this.taskIds) ? this.taskIds.join(', ') : '';
    }
    get dashboardStatusDisplayText() {
        let dashboardStatus = null;
        if (Utils.isTrue(this.dashboardProblematic)) {
            dashboardStatus = 'Problematic';
        }
        else if (Utils.isTrue(this.dashboardPriority)) {
            dashboardStatus = 'Priority';
        }
        return dashboardStatus;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Date)
], WorkFlowWorkOrderResultDto.prototype, "createDate", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], WorkFlowWorkOrderResultDto.prototype, "responsible", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], WorkFlowWorkOrderResultDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Date)
], WorkFlowWorkOrderResultDto.prototype, "dueDate", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", Array)
], WorkFlowWorkOrderResultDto.prototype, "dashboardResponsible", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", Array)
], WorkFlowWorkOrderResultDto.prototype, "primaryAcam", void 0);
tslib_1.__decorate([
    Type(ɵ6),
    tslib_1.__metadata("design:type", Array)
], WorkFlowWorkOrderResultDto.prototype, "primaryCam", void 0);
tslib_1.__decorate([
    Type(ɵ7),
    tslib_1.__metadata("design:type", Date)
], WorkFlowWorkOrderResultDto.prototype, "statusChanged", void 0);
tslib_1.__decorate([
    Type(ɵ8),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], WorkFlowWorkOrderResultDto.prototype, "statusChangedBy", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8 };
